import { ICancelablePromise } from '@Core/Animation/SpineWrapper';
import { ESymbolsHighlighterPhases } from './SymbolsHighlighterPhases';

export interface ISymbolsHighlightPresenter {
    show(cycleStep: CycleStep): ICancelablePromise[];
    hide(): void;
    getAnimationDuration(cycleIndex?: number): number;
}

export enum CycleStepType {
    MAIN = 'MAIN',
    SCATTER = 'SCATTER'
}

interface BaseCycleStep {
    type: CycleStepType;
    phase: ESymbolsHighlighterPhases;
    selectionMask: boolean[][];
    cycleIndex: number;
    index: number;
    multiplier?: number;
    onlyInterchangeableSymbols: boolean;
    symbolId: number;
}

export interface ScatterCycleStep extends BaseCycleStep {
    type: CycleStepType.SCATTER;
}

export interface WaysCycleStep extends BaseCycleStep {
    type: CycleStepType.MAIN;
}

export interface WinlineCycleStep extends BaseCycleStep {
    type: CycleStepType.MAIN;
    paylineId: number;
    payline: number[];
}

export type CycleStep = ScatterCycleStep | WaysCycleStep | WinlineCycleStep;
